import { render, staticRenderFns } from "./ShowAskExperience.vue?vue&type=template&id=272b5077&scoped=true&"
import script from "./ShowAskExperience.vue?vue&type=script&lang=ts&"
export * from "./ShowAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./ShowAskExperience.vue?vue&type=style&index=0&id=272b5077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b5077",
  null
  
)

export default component.exports